import React from 'react';
import Button from '../../Button';
import './TableToolbar.scss';

const TableToolbar = (props) => {
  const {
    total,
    hasUsedCheckbox,
    hasFilter,
    hasExelDownloadButton,
    onClickExcelDownload,
    onClickResetFilter,
    deleteCheckedIdList,
    checkedIdList,
  } = props;

  return (
    <div className="summary">
      <span className="total-cnt">
        <span className="cnt">{total}</span>건이 조회되었습니다.
      </span>
      <div className="button-group">
        {/* isUsedCheckbox 값이 false이거나 deleteCheckedIdList 함수를 정의 해주지 않으면 해당 버튼이 노출될 필요가 없습니다. */}
        {hasUsedCheckbox && (
          <Button isRadius color="primary" text="삭제" disabled={!checkedIdList.length} onClick={deleteCheckedIdList} />
        )}
        {/* getExcelSheet 함수를 정의 해주지 않으면 해당 버튼이 노출될 필요가 없습니다. */}
        {hasExelDownloadButton && (
          <Button isRadius color="primary" text="엑셀다운" alt="엑셀다운로드" onClick={onClickExcelDownload} />
        )}
        {hasFilter && (
          <Button isRadius color="primary" text="필터 초기화" alt="필터초기화" onClick={onClickResetFilter} />
        )}
      </div>
    </div>
  );
};

export default TableToolbar;
